import angular from "angular";
import template from "./admin-view-time-off-requests.html";
import AdminViewTimeOffRequestsController from "./admin-view-time-off-requests.controller";
import TimeOffRequestView from "./view/admin-time-off-request-detail.module";
function config($stateProvider, $urlRouterProvider, USER_ROLES) {
  $stateProvider.state("drivecoach.admin.instructors.timeoffrequests", {
    url: "/time-off-requests",
    controller: AdminViewTimeOffRequestsController,
    controllerAs: "vm",
    template: template,
    data: {
      authorizedRoles: [
        USER_ROLES.admin,
        USER_ROLES.administrator,
        USER_ROLES.owner,
      ],
    },
  });
}
config.$inject = ["$stateProvider", "$urlRouterProvider", "USER_ROLES"];

export default angular
  .module("admin.dashboard.instructors.timeoffrequests", [
    TimeOffRequestView.name,
  ])
  .config(config)
  .controller(
    "AdminViewTimeOffRequestsController",
    AdminViewTimeOffRequestsController,
  );
